import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const CancelIcon = withSvgIcon(
    <g>
        <path d="M450 106.8L393.2 50 250 193.2 106.8 50 50 106.8 193.2 250 50 393.2l56.8 56.8L250 306.8 393.2 450l56.8-56.8L306.8 250z" />
    </g>
);
